import { getPermissions } from 'api';
import { useParams } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { PermissionArray, permissionState } from 'state/permissionState';
import { GeneralIds } from 'types/types';
import useRequest from './useRequest';

export default function usePermissions() {
  const { projectId } = useParams<GeneralIds>();
  const setPermissions = useSetRecoilState(permissionState);

  const { loading } = useRequest<PermissionArray>(
    getPermissions,
    {
      dependencies: [projectId],
      set: {
        data: setPermissions,
      },
    },
    [projectId],
  );

  return { loading };
}
